import { useState } from "react";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { getHotMovies, getLatestMovies } from "@/utils/movies";

const tabs = [
  { key: "hot", label: "热门精选" },
  { key: "latest", label: "最新更新" },
];

export default function FeaturedGrid() {
  const [tab, setTab] = useState("hot");
  const list = tab === "hot" ? getHotMovies(8) : getLatestMovies(8);

  return (
    <section className="max-w-6xl mx-auto px-4 md:px-6 mt-12 md:mt-16">
      <SectionHeading
        title="精选推荐"
        subtitle="根据热度与更新情况为你甄选的影视作品"
        moreTo="/category?type=movie"
        moreLabel="进入分类"
      />

      <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-200 mb-5">
        {tabs.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => setTab(item.key)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              tab === item.key
                ? "bg-background-50 text-primary-700"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}